import { FC, PropsWithChildren, ReactNode } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  disableExitButton?: boolean;
  disableOutsideClick?: boolean;
  maxWidth?: string;
  title: string | ReactNode;
  description?: string | ReactNode;
  actions?: (arg: { close: () => void }) => ReactNode;
}

export const DialogComponent: FC<PropsWithChildren<Props>> = ({
  isOpen,
  onClose,
  disableExitButton,
  disableOutsideClick,
  maxWidth,
  title,
  description,
  actions,
  children,
}) => (
  <Dialog
    open={isOpen}
    scroll="body"
    fullWidth
    maxWidth={false}
    onClose={(_event, reason) => {
      if (
        disableOutsideClick &&
        (reason === "backdropClick" || reason === "escapeKeyDown")
      ) {
        return;
      }
      onClose();
    }}
    sx={{
      "& .MuiPaper-root": {
        width: "100%",
        maxWidth: maxWidth ?? 800,
        padding: 3,
        borderRadius: 4,
        boxSizing: "border-box",
        "@media (max-width: 900px)": {
          margin: 2,
          maxWidth: "90vw",
        },
      },
    }}
  >
    {!disableExitButton && (
      <IconButton
        aria-label="close"
        onClick={onClose}
        sx={{
          position: "absolute",
          right: "8px",
          top: "8px",
        }}
      >
        <CloseIcon />
      </IconButton>
    )}
    <DialogTitle>{title}</DialogTitle>
    <DialogContent dividers sx={{ mb: 2, borderTop: "none" }}>
      {description && (
        <DialogContentText sx={{ my: 1, pb: children ? 1 : 0 }} component="div">
          <Typography variant="body1">{description}</Typography>
        </DialogContentText>
      )}
      {children}
    </DialogContent>
    {actions && (
      <DialogActions disableSpacing sx={{ mt: 1, gap: 2 }}>
        {actions({ close: onClose })}
      </DialogActions>
    )}
  </Dialog>
);
